import { ReactNode, useEffect } from 'react';
import { FleetManagementState } from './FleetManagementState.ts';
import { useInstance } from '../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';

export const EnsureFleetLoaded: React.FC<{children: ReactNode}> = ({ children }) => {
    const fleetState = useInstance(FleetManagementState);
    useSubscription(() => fleetState);

    useEffect(() => {
        fleetState.ensureLoaded();
    }, [fleetState]);

    if (fleetState.loaded) {
        return (
            <>{children}</>
        );
    } else {
        return null;
    }
};
